import { useEffect, useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { X } from "lucide-react";

const AvatarPreviewBridge = () => {
  const [src, setSrc] = useState<string | null>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      const target = e.target as HTMLElement | null;
      if (!target) return;
      const img = target.closest('img[data-avatar-preview="true"]') as HTMLImageElement | null;
      if (!img || !img.src) return;
      // Don't hijack file-input/edit triggers
      if (target.closest('button,a,input,label')) return;
      e.preventDefault();
      e.stopPropagation();
      setSrc(img.src);
    };
    document.addEventListener("click", handler, true);
    return () => document.removeEventListener("click", handler, true);
  }, []);

  return (
    <Dialog open={!!src} onOpenChange={(o) => { if (!o) setSrc(null); }}>
      <DialogContent className="max-w-lg p-0 bg-transparent border-0 shadow-none" aria-describedby={undefined}>
        <div className="relative rounded-3xl overflow-hidden bg-card">
          <button
            onClick={() => setSrc(null)}
            className="absolute top-2 right-2 z-10 w-9 h-9 rounded-full bg-foreground/60 text-background flex items-center justify-center hover:bg-foreground/80 transition-colors"
            aria-label="Fermer"
          >
            <X className="w-5 h-5" />
          </button>
          {src && (
            <img src={src} alt="Aperçu" className="w-full h-auto object-contain max-h-[80vh]" />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AvatarPreviewBridge;